export default "__VITE_ASSET__oDWZwZTU__"